<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="closeModal()">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="text-center mb-4">
            <span class="modal-title"> {{ 'PATIENT_ID_MODAL.TITLE' | translate }} </span>
        </div>
        <form role="form" [formGroup]="form" novalidate>
            <div class="form-group">
                <input ngbAutofocus type="text" class="form-control"
                    placeholder=" {{ 'PATIENT_ID_MODAL.PLACEHOLDER' | translate }}"
                    [ngClass]="{'is-valid': !idControl.invalid, 'is-invalid': idControl.invalid && idControl.touched}"
                    formControlName="id">
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': idControl.invalid && idControl.touched ? 'block' : 'none'}">
                    <span> {{ 'PATIENT_ID_MODAL.ERROR' | translate }} </span>
                </div>
            </div>
            <div class="text-center mb-4 analysis-title">
                <span class="modal-title"> {{ 'PATIENT_ID_MODAL.SAMPLE_TYPE' | translate }} </span>
            </div>
            <div class="form-group">
                <mat-radio-group aria-labelledby="radio-group-label" class="analysis-radio-group"
                    formControlName="analysisType">
                    @for (analysis of analysisTypes; track analysis) {
                    <mat-radio-button class="analysis-radio-button" [value]="analysis.id"
                        [disabled]="!analysis.enabled">{{ 'PATIENT_ID_MODAL.' + analysis.name |translate }}</mat-radio-button>
                    }
                </mat-radio-group>
                <div class="text-center invalid-feedback"
                    [ngStyle]="{'display': analysisTypeControl.invalid && analysisTypeControl.touched ? 'block' : 'none'}">
                    <span> {{ 'PATIENT_ID_MODAL.SELECT_SAMPLE_TYPE' | translate }} </span>
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center mt-4">
            <button type="button" class="modal-ok-btn" (click)="save()"> {{'CONSTANTS.BTN_UPLOAD' |
                translate }} </button>
        </div>
    </div>
</ng-template>
